export default __webpack_public_path__ + "static/blob2-818febd4eb9df05bab508e4f865487ed.svg";